import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconInfo = ({ color = 'var(--color-semantic-3)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="7.5" fill={color} stroke={color} />
            <circle cx="8.18137" cy="4.54539" r="0.727273" fill="white" />
            <rect x="7.63672" y="6.36353" width="1.09091" height="6" fill="white" />
        </svg>
    </div>
);

export default IconInfo;
